import { useAuth, overrideConfig } from '@/api/billing-primary'

const fetchDataTransfersResourceId = function ({ projectIdx, month, resourceId }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.post('/v1/context', { target: 'DataTransfersResourceId', params: { projectIdx: [projectIdx], month, resourceId } })
}

const fetchDataTransfers = function ({ projectIdx, month }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.post('/v1/context', { target: 'DataTransfers', params: { projectIdx: [projectIdx], month } })
}

export default {
    fetchDataTransfers,
    fetchDataTransfersResourceId
}
